import { useCallback, useEffect, useState } from 'react'
import { Button, Input } from 'components/shared'
import { classNameJoin } from 'utils/lib'
import { ReactComponent as CheckIcon } from '../../../assets/ic_check.svg'
import { ServiceTerm } from './ServiceTerm'
import { Register } from 'interfaces/user.interface'

const Category = ['여성의류', '남성의류', '식품', '잡화', '아동복', '팬시', '뷰티']
const Platform = [
    '인스타그램',
    '네이버밴드',
    '틱톡',
    '유튜브',
    '네이버 쇼핑 라이브',
    '그립',
    '기타',
]

interface StepOneProps {
    item: Register
    callback: (key: keyof Register, value: string) => void
}

export const StepThree = ({ item, callback }: StepOneProps) => {
    const [recommender, setRecommender] = useState<string>(item.recommender ?? '')
    const [snsLinks, setSnsLinks] = useState<string>(item.snsLinks ?? '')
    const [refferralPath, setReferralPath] = useState<string>(item.referralPath ?? '')

    const [selectedCategory, setSelectedCategory] = useState<string[]>(
        item.salesCategory?.split(',') ?? []
    )
    const [selectedPlatform, setSelectedPlatform] = useState<string[]>(
        item.liveHistory?.split(',') ?? []
    )

    const toggleSelection = (
        value: string,
        selectedList: string[],
        setSelectedList: (list: string[]) => void,
        type: 'category' | 'platform'
    ) => {
        let result: string[]
        if (selectedList.includes(value)) {
            result = selectedList.filter((item) => item !== value)
            setSelectedList(result)
        } else {
            result = [...selectedList, value]
            setSelectedList(result)
        }

        if (type === 'category') {
            callback('salesCategory', result.join(','))
        } else {
            callback('liveHistory', result.join(','))
        }
    }

    const handleServiceTermChange = useCallback((checked: boolean) => {
        const _ = callback as any
        _('termsAll', `${checked}`)
    }, [])

    return (
        <section className="flex flex-col gap-10 w-full items-center">
            <article className="flex flex-col gap-1">
                <h2 className="text-[clamp(18px,3vw,22px)] font-bold text-[#242424]">
                    마지막으로 셀러님에 대해 간단하게 알려주세요!
                </h2>
                <p className="text-[clamp(14px,3vw,18px)] font-normal text-[#898989] break-keep">
                    셀러님께 드릴 수 있는 맞춤 혜택이 있는지 확인해드릴게요.
                </p>
            </article>

            {/* 추천인 */}
            <article className="flex flex-col gap-2 w-full items-start">
                <label className="text-[clamp(14px,3vw,18px)] font-medium text-[#565656]">
                    추천인
                </label>
                <Input
                    value={recommender}
                    type="text"
                    className="w-full h-[clamp(44px,3vw,52px)]"
                    inputClassName="text-[clamp(14px,3vw,18px)] border-[#c1c1c1]"
                    placeholder="추천한 셀러 닉네임 입력"
                    maxLength={20}
                    onChange={(e) => {
                        const value = e.target.value
                        if (value.length > 20) {
                            setRecommender(value.slice(0, 20))
                            return
                        }
                        setRecommender(value)
                    }}
                    onBlur={() => {
                        callback('recommender', recommender ?? '')
                    }}
                />
            </article>

            {/* SNS 링크 */}
            <article className="flex flex-col gap-2 w-full items-start">
                <label className="text-[clamp(14px,3vw,18px)] font-medium text-[#565656]">
                    운영하고 계신 SNS 링크
                </label>
                <Input
                    value={snsLinks}
                    type="text"
                    className="w-full h-[clamp(44px,3vw,52px)]"
                    inputClassName="text-[clamp(14px,3vw,18px)] border-[#c1c1c1]"
                    placeholder="운영하고 계신 SNS 링크 입력"
                    maxLength={200}
                    onChange={(e) => {
                        const value = e.target.value
                        if (value.length > 200) {
                            setSnsLinks(value.slice(0, 200))
                            return
                        }
                        setSnsLinks(value)
                    }}
                    onBlur={() => {
                        callback('snsLinks', snsLinks ?? '')
                    }}
                />
            </article>

            {/* 판매 카테고리 */}
            <article className="flex flex-col gap-2 w-full items-start">
                <label className="text-[clamp(14px,3vw,18px)] font-medium text-[#565656]">
                    판매 카테고리 <span className="text-[#c1c1c1]">(복수 선택 가능)</span>
                </label>
                <div className="flex flex-col gap-2 w-full">
                    {Category.map((item) => {
                        const isSelected = selectedCategory.includes(item)
                        return (
                            <Button
                                key={item}
                                ghost={!isSelected}
                                onClick={() =>
                                    toggleSelection(
                                        item,
                                        selectedCategory,
                                        setSelectedCategory,
                                        'category'
                                    )
                                }
                                className={classNameJoin([
                                    'w-full h-[clamp(44px,3vw,52px)] flex items-center justify-between',
                                    'text-bold text-[clamp(14px,3vw,20px)]',
                                ])}
                            >
                                <p className="text-[clamp(14px,3vw,18px)]">{item}</p>
                                <CheckIcon
                                    className={classNameJoin([
                                        'w-[clamp(20px,3vw,24px)] h-[clamp(20px,3vw,24px)]',
                                        isSelected ? 'fill-[#FFFFFF]' : 'fill-[#898989]',
                                    ])}
                                />
                            </Button>
                        )
                    })}
                </div>
            </article>

            {/* 클릭메이트 알게된 경로 */}
            <article className="flex flex-col gap-2 w-full items-start">
                <label className="text-[clamp(14px,3vw,18px)] font-medium text-[#565656]">
                    클릭메이트 알게된 경로
                </label>
                <Input
                    value={refferralPath}
                    type="text"
                    className="w-full h-[clamp(44px,3vw,52px)]"
                    inputClassName="text-[clamp(14px,3vw,18px)] border-[#c1c1c1]"
                    placeholder="클릭메이트 알게된 경로 입력"
                    maxLength={30}
                    onChange={(e) => {
                        const value = e.target.value
                        if (value.length > 30) {
                            setReferralPath(value.slice(0, 30))
                            return
                        }
                        setReferralPath(value)
                    }}
                    onBlur={() => {
                        callback('referralPath', refferralPath ?? '')
                    }}
                />
            </article>

            {/* 플랫폼 선택 */}
            <article className="flex flex-col gap-2 w-full items-start">
                <label className="text-[clamp(14px,3vw,18px)] font-medium text-[#565656]">
                    라이브 경험이 있다면 활동한 플랫폼{' '}
                    <span className="text-[#c1c1c1]">(복수 선택 가능)</span>
                </label>
                <div className="flex flex-col gap-2 w-full">
                    {Platform.map((item) => {
                        const isSelected = selectedPlatform.includes(item)
                        return (
                            <Button
                                key={item}
                                ghost={!isSelected}
                                onClick={() =>
                                    toggleSelection(
                                        item,
                                        selectedPlatform,
                                        setSelectedPlatform,
                                        'platform'
                                    )
                                }
                                className={classNameJoin([
                                    'w-full h-[clamp(44px,3vw,52px)] flex items-center justify-between',
                                    'text-bold',
                                ])}
                            >
                                <p className="text-[clamp(14px,3vw,18px)]">{item}</p>
                                <CheckIcon
                                    className={classNameJoin([
                                        'w-[clamp(20px,3vw,24px)] h-[clamp(20px,3vw,24px)]',
                                        isSelected ? 'fill-[#ffffff]' : 'fill-[#898989]',
                                    ])}
                                />
                            </Button>
                        )
                    })}
                </div>
            </article>

            {/* 약관 동의 */}
            <ServiceTerm onChange={handleServiceTermChange} />
        </section>
    )
}
